import { pick, round } from "lodash";

import AppConstants from "@/constants/AppConstants";
import PROPERTY_MAPS from "@/constants/PropertyMaps";

const { ELEMENT_POSITION } = PROPERTY_MAPS;

/**
 * @typedef {import("@/types/ElementTypes.mjs").DimensionPosition} DimensionPosition
 * @typedef {Pick<any, "w" | "h" | "x" | "y" | "a"> & Partial<{container: DimensionPosition}>} SatisfiedDimensionPosition
 */

/**
//  * Returns center point for dimensionPosition
//  * @param {DimensionPosition} data 
//  * @param {boolean} withOffsets - include x/y into calculation
//  * @returns {import("@/types/MathTypes.mjs").Coordinates}
//  */
// export const getCenterPoint = (data, withOffsets = true) => {
//   const center = [data.w / 2, data.h / 2];
  
//   if(withOffsets) {
//     center[0] += data.x;
//     center[1] += data.y;
//   }

//   return center;
// };

 /**
   * Gets dimensionPosition for a single element info. Rounds values.
   * @param {SatisfiedDimensionPosition} elemInfo - Doesn't necessarily need to be an explicit elemInfo object, but should include a dimensionPosition base with a container dimensionPosition if necessary.
   * @param {boolean=} ignoreContainerRotation - Ignores removing container position.
   * This is for elements coming straight from data and not in design space from the transform process (as in they only have their own rotation.
   * @returns {DimensionPosition}
   */
 export const getDimensionPosition = (elemInfo, ignoreContainerRotation = false) => {
  return Object.entries(pick(elemInfo, ELEMENT_POSITION)).reduce((result, [key, value]) => {
    const rounded = round(value, AppConstants.DECIMAL_PRECISION);
    result[key] =
      key === "a" && elemInfo.container && !ignoreContainerRotation
        ? // removes container's rotation
          rounded - elemInfo.container.a
        : // prevents zero dimensions
        (key === "w" || key === "h") && !rounded
        ? 1
        : rounded;
    return result;
  }, {});
};

/**
 * Prepares positions. Expected to be a Map of elementId: dimensionData
 * @param {import("@/types/TypeUtils.mjs").ImmutableMapFrom<Record<string, SatisfiedDimensionPosition>>} positions
 * @param {boolean=} ignoreContainerRotation - Ignores removing container position.
 * This is for elements coming straight from data and not in design space from the transform process (as in they only have their own rotation)
 * @returns {import("immutable").Iterable<string, DimensionPosition>}
 */
export const gatherDimensionPositions = (positions, ignoreContainerRotation = false) => positions.map((elemInfo) =>
    getDimensionPosition(elemInfo, ignoreContainerRotation)
  );